import { ChartHelper } from "src/app/standalone components/helpers/chart-helper";
import { BarChartData } from "../../types/bar-chart-data";
import { ChartDataSet } from "../../types/chart-data-set";
import { IChart } from "../interfaces/i-chart";

export class HorizontalBarChart implements IChart {

    constructor() { }
    getChartOptions(data: ChartDataSet[] = [], displayLegend: boolean = false) {
        let options = {
            indexAxis: 'y',
            responsive: true,
            plugins: {
                legend: {
                    display: displayLegend,
                    position: 'bottom'
                },
                title: {
                    display: true,
                    text: data[0].label ?? 'Sem título'
                }
            }
        }
        return options;
    }

    colors!: string[];

    setColors(colors: string[]): void {
        this.colors = colors;
    }

    /**
     * Gera um gráfico de barras
     * @param data dados do gráfico (Ex.: [{ key: 'Sales', value: 20 }, { key: 'Revenue', value: 10 }])
     * @returns BarChartData
     */
    public getChartData(data: ChartDataSet[]): BarChartData {

        const groupedData = ChartHelper.groupDataByLabel(data);
        const datasets: any = this.buildDataSet(groupedData);
        const barChartData: BarChartData = {
            datasets: datasets
        };

        return barChartData;
    }

    private getBorderColor(): string {
        return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
            ? '#fff' // cor clara para dark mode
            : '#232a3b'; // cor escura para light mode
    }

    /**
     * 
     * @param groupedData Record<string, ChartDataSet[]
     * This parameter is basically the ChartData grouped by its labels
     * @returns 
     */
    private buildDataSet(groupedData: any): any {
        var borderColor = this.getBorderColor();
        var dataset = Object.keys(groupedData).map(label =>
        ({
            label: label,
            data: groupedData[label].data,
            parsing: {
                xAxisKey: 'value',
                yAxisKey: 'key',
            },
            backgroundColor: ChartHelper.empty(groupedData[label].colors) ? this.colors : groupedData[label].colors,
            borderColor: borderColor,
            borderWidth: 2,
            maxBarThickness: 50
        })
        );

        return dataset;
    }

}